import {useMemo} from 'react';
import {range} from '../helper';
export const DOTS = '...';

interface UsePaginateProps {
  totalCount: number;
  pageSize: number;
  siblingCount: number;
  currentPage: number;
}
export const usePaginate = ({
  totalCount,
  pageSize,
  siblingCount = 1,
  currentPage,
}: UsePaginateProps) => {
  const paginationRange = useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);

    const totalPageNumbers = siblingCount + 5;

    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
      currentPage + siblingCount,
      totalPageCount,
    );

    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;

    const pagination = [];

    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = 3 + 2 * siblingCount;
      const leftRange = range(1, leftItemCount);
      pagination.push(...leftRange, DOTS, totalPageCount);
    } else if (shouldShowLeftDots && shouldShowRightDots) {
      const middleRange = range(leftSiblingIndex, rightSiblingIndex);
      pagination.push(1, DOTS, ...middleRange, DOTS, totalPageCount);
    } else if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = 2 + 2 * siblingCount;
      const rightRange = range(
        totalPageCount - rightItemCount + 1,
        totalPageCount,
      );
      pagination.push(1, DOTS, ...rightRange);
    }

    return pagination;
  }, [totalCount, pageSize, siblingCount, currentPage]);

  return paginationRange;
};
